import { Component } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ActivatedRoute, Router } from '@angular/router';

// 4DKING (transfer wallet) bet history — read-only. Reads the fourdking_bet/strike rows
// landed by the backend sync (POST /admin/transfer/4dking/bet-history). Mirrors the
// Game Log page: date range + player code/mobile + 4DKING username search.
@Component({
  selector: 'app-fourdking-bet-history',
  templateUrl: './fourdking-bet-history.component.html',
  styleUrls: ['./fourdking-bet-history.component.scss']
})
export class FourdkingBetHistoryComponent {

  public data: any = { match: 'exact' };
  public load: any = false;
  public items: any = [];
  public summary: any = {};
  public page_nat: any = { current_page: 1, per_page: 200, total: 0, total_page: 0 };
  private selected_company: any = null;

  constructor(private http: HttpService, private activatedRoute: ActivatedRoute, private router: Router) {
    this.selected_company = this.http.getStaticSelectedCompany();

    const q = this.activatedRoute.snapshot.queryParams;
    let available = false;
    ['page_no', 'date_from', 'date_to', 'code', 'mobile', 'username', 'match'].forEach((k) => {
      if (q[k]) { this.data[k] = q[k]; available = true; }
    });

    const date = new Date();
    const today = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
    if (!this.data.date_from) this.data.date_from = today + 'T00:00';
    if (!this.data.date_to) this.data.date_to = today + 'T23:59';

    if (available) {
      if (this.data.date_from > this.data.date_to) {
        [this.data.date_from, this.data.date_to] = [this.data.date_to, this.data.date_from];
      }
      this.filter(q['page_no'] ? q['page_no'] : 1);
    }
  }

  async filter(page_no = 1) {
    this.load = true;
    this.data.page_no = page_no;

    const payload = { ...this.data };
    let y: any = await this.http.post('/admin/transfer/4dking/bet-history', payload);

    if (y && y.status) {
      this.items = y.items || [];
      this.summary = y.summary || {};
      this.page_nat = y.page_nat || this.page_nat;

      const queryParams = { ...this.data };
      delete queryParams.user_uuid;
      delete queryParams.company_uuid;
      this.router.navigate(['/lo', this.selected_company, 'fourdking-bet-history'], { queryParams, replaceUrl: true });
    } else {
      this.items = [];
      this.summary = {};
    }
    this.load = false;
  }

  sum(key: string) {
    return this.items.reduce((acc: any, item: any) => acc + parseFloat(item[key] ?? 0), 0);
  }
}
